import tag from '../utilComponents.js';
import Keyset from '../keyset/keyset.js';

import * as styles from './keyboard.module.scss';

const keyboard = tag.div(
  { classes: [styles.keyboard] },
  new Keyset('digits'),
  new Keyset('letters')
);
export default keyboard;
